import { Component, OnInit } from '@angular/core';
import { ParticipanteService } from '../participantes/participante.service';
import { AuthAndACLService } from '../auth_and_acl/authAndACL.service';
import { Usuario } from './../usuario/usuario';
import { Utils } from './../shared/utils';

import { PER_PAGE } from './../constante';

@Component({
  selector: 'app-meus-documentos',
  templateUrl: './meus-documentos.component.html',
  styleUrls: ['./meus-documentos.component.css'],
  providers: [ParticipanteService, Utils]
})
export class MeusDocumentosComponent implements OnInit {
  public titulo: string = "Sistema de Certificados e Documentos";
  public usuario: Usuario;
  public busy: Promise<any>;
  public certificados: any;
  public paginaAtual: number = 1;
  public itensPorPagina: number = PER_PAGE;
  public startDate: string;
  public endDate: string;

  constructor(public authAndACL: AuthAndACLService, public participanteService: ParticipanteService, public utils: Utils) { }

  pesquisar():void{
    let params: any = {};
    if(this.startDate && this.endDate){
      params.criado_em_from = this.startDate;
      params.criado_em_to = this.endDate;
    }
    this.busy = this.participanteService.meusCertificados(params as any)
        .then((response) => {
          this.certificados = response
        })
        .catch((error) => this.certificados = []);
  }

  ngOnInit() {
    this.pesquisar();
  }

}



// WEBPACK FOOTER //
// ./src/app/meus-documentos/meus-documentos.component.ts